import { useState, useEffect } from 'react';

const useFPVStorage = (key = 'fpv') => {
  // 1. Initialize State
  // We use a lazy initializer to read from localStorage only once on mount
  const [storedArray, setStoredArray] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      // If key exists, parse and return it. If not, return empty array.
      return item ? JSON.parse(item) : [];
    } catch (error) {
      console.error("Error reading from localStorage:", error);
      return [];
    }
  });

  // 2. The 'Add' Function
  // Receives a single JSON object and appends it to the array
  const addObject = (newObject) => {
    try {
      // Update state using the previous state to ensure accuracy
      setStoredArray((prevArray) => {
        // Create the new array
        const newArray = [...prevArray, newObject];
        
        // Save to LocalStorage immediately
        // JSON.stringify formats it correctly for storage
        window.localStorage.setItem(key, JSON.stringify(newArray));
        
        return newArray;
      });
    } catch (error) {
      console.error("Error saving to localStorage:", error);
    }
  };

  // 3. Optional: A 'Clear' function
  // Useful if you need to reset the data
  const clearStorage = () => {
    try {
      window.localStorage.removeItem(key);
      setStoredArray([]);
    } catch (error) {
      console.error("Error clearing localStorage:", error);
    }
  };

  // Return the array (data) and the function to update it (save)
  return { 
    data: storedArray, 
    save: addObject,
    clear: clearStorage
  };
};

export default useFPVStorage;